export default __webpack_public_path__ + "static/cat1-e913e0d09fab316d70ad072b623e847b.jpg";